export const MONITOR_CARD_HEIGHT = {
  DETAILS: 328,
  SUMMARY: 240,
  VARIANT_BREAKDOWN: 240,
  VARIANT_PERFORMANCE: 488,
  VARIANT_PERFORMANCE_CHART: 450,
};
